import { render } from "./ShipmentAdd.vue?vue&type=template&id=881508d0&scoped=true"
import script from "./ShipmentAdd.vue?vue&type=script&lang=js"
export * from "./ShipmentAdd.vue?vue&type=script&lang=js"

import "./ShipmentAdd.vue?vue&type=style&index=0&id=881508d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-881508d0"]])

export default __exports__